import { string } from 'prop-types';
import { connect } from 'react-refetch';
import { compose, defaultProps, setDisplayName, setPropTypes, withProps, withPropsOnChange } from 'recompose';
import { Layout } from '../../constants/Layout';
import { MainSource } from '../../constants/Source';
import { withItemsActions } from '../../utils/hoc/withItemsActions';
import { PreventSubscribeEventsNames } from '../../utils/hoc/withItemsActions/withItemsActions';
import { withItemsReducer } from '../../utils/hoc/withItemsReducer';
import { withMediaManagerSDK } from '../../utils/hoc/withMediaManagerSDK';
import { withMMGRSettings } from '../../utils/hoc/withMMGRSettings';
import { IInner, IOuter } from './Home.types';

const emptyItems = [];

export const enhance = compose<IInner, IOuter>(
  setPropTypes({
    fileType: string.isRequired,
  }),
  setDisplayName('HomeEnhancer'),
  defaultProps({
    nextPageItems: [],
    recommendedItems: [],
    items: [],
    layout: Layout.SmartGrid,
    layouts: [Layout.SmartGrid],
  }),
  withMMGRSettings,
  withProps(({ mmgrSettings: { openSource, customData } }) => ({
    openSource,
    customData,
  })),
  withMediaManagerSDK({ source: MainSource.SiteFiles }),
  connect<any>(({ getRecentFilesMP }) => ({
    recentFilesCategoriesRequest: {
      comparison: '',
      value: getRecentFilesMP,
    },
  })),
  withProps(({ recentFilesCategoriesRequest, recommendedItems, isLoading }) => {
    const { fulfilled, rejected } = recentFilesCategoriesRequest;
    const isLoadingRecentItems = !fulfilled && !rejected;

    const recentItems = isLoadingRecentItems || rejected ? emptyItems : recentFilesCategoriesRequest.value.data;
    const recommendedADIItems = emptyItems;
    const recommendedADITitle = '';

    return {
      isLoadingRecentItems,
      isLoadingRecommendedItems: isLoading,
      recommendedItems,
      recommendedADIItems,
      recommendedADITitle,
      recentItems,
      source: MainSource.Home,
    };
  }),
  withPropsOnChange(
    ['isLoadingRecentItems', 'isLoadingRecommendedItems'],
    ({ isLoadingRecentItems, recentItems, recommendedItems, isLoadingRecommendedItems, recommendedADIItems }) => {
      if (!isLoadingRecentItems && !isLoadingRecommendedItems) {
        return {
          items: [...recommendedADIItems, ...recentItems, ...recommendedItems],
          isLoading: false,
        };
      }

      return !isLoadingRecentItems
        ? {
            items: [...recommendedADIItems, ...recentItems],
            isLoading: false,
          }
        : !isLoadingRecommendedItems
        ? {
            items: [...recommendedADIItems, ...recommendedItems],
            isLoading: false,
          }
        : { items: [...recommendedADIItems], isLoading: true };
    },
  ),
  withItemsReducer,
  withItemsActions({
    preventSubscribeEvents: [
      PreventSubscribeEventsNames.JumpToNextItemHotKey,
      PreventSubscribeEventsNames.JumpToPrevItemHotKey,
      PreventSubscribeEventsNames.JumpToBottomItemHotKey,
      PreventSubscribeEventsNames.JumpToTopItemHotKey,
      PreventSubscribeEventsNames.SelectAllItemsHotKey,
    ],
  }),
);
